import Vue from 'vue'
import Router from 'vue-router'
import comp from './comp'
import axios from 'axios'
import {Cookie} from '@/util'
import store from '@/store'

const index = () => import('@/pages/index')
const Login = () => import('@/pages/Login')
const AgentError = () => import('@/pages/AgentError')
Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: '/account/keepAccounts',
    name: 'index',
  },
  {
    path: '/agentError',
    name: 'agentError',
    component: AgentError
  },
  {
    path: '/index',
    name: 'index',
    redirect: '/account/keepAccounts',
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/account',
    name: 'account',
    component: comp.Account,
    redirect: '/account/keepAccounts',
    children: [{
      path: '/account/keepAccounts',
      name: 'keepAccounts',
      component: comp.Account_KeepAccounts
    },{
      path: '/account/checkAccounts',
      name: 'CheckAccounts',
      component: comp.Account_CheckAccounts
    }]
  },
  {
    path:'/setting',
    name: 'setting',
    component: comp.Setting,
    redirect: '/setting/team',
    children: [{
      path: '/setting/team',
      name: 'teamSetting',
      component: comp.Setting_Team
    },{
      path: '/setting/position',
      name: 'positionSetting',
      component: comp.Setting_Position
    },{
      path: '/setting/job',
      name:'jobSetting',
      component: comp.Setting_Job
    },{
      path:'/setting/role',
      name:'roleSetting',
      component: comp.Setting_Role
    },{
      path: '/setting/teamer',
      name: 'teamerSetting',
      component: comp.Setting_Teamer,
    },{
      path:'/setting/teamer/memberEdit',
      name:'memberEdit',
      component:comp.Setting_MemberSetting,
    },{
      path: '/setting/subject',
      name: 'subjectSetting',
      component: comp.Setting_Subject
    },{
      path: '/setting/personal',
      name: 'personalSetting',
      component: comp.Setting_Personal
    },{
      path: '/setting/permission',
      name: 'permissionSetting',
      component: comp.Setting_Permission
    },{
      path: '/setting/company',
      component: comp.Setting_Company
    },{
      path: '/setting/handleRecord',
      component: comp.Setting_HandleRecord
    },{
      path:'/setting/management',
      component: comp.Setting_Management
    },{
      path:'/setting/help-center-list',
      component: comp.Setting_HelpCenterList
    },{
      path:'/setting/guideConfig',
      component: comp.Setting_Config
    },{
      path:'/setting/serverSetting',
      component: comp.Setting_ServerSetting
    },{
      path:'/setting/deviceGrant',
      component: comp.Setting_DeviceGrantSetting
    },{
      path:'/setting/dictionary',
      component: comp.Setting_Dictionary
    }]
  },
  {
    path:'/helpCenter',
    name:'helpCenter',
    component:comp.HelpCenter,
    redirect:'/helpCenter/HelpDoc',
    children: [{
      path:'/helpCenter/HelpDoc',
      name:'HelpDoc',
      component: comp.HelpCenter_HelpDoc
    },{
      path:'/helpCenter/HelpQuestionPage',
      name:'HelpQuestionPage',
      component: comp.HelpCenter_HelpQuestionPage,
    },{
      path:'/helpCenter/AnswerQuestionPage',
      name:'AnswerQuestionPage',
      component: comp.HelpCenter_AnswerQuestionPage,
    },{
      path:'/helpCenter/HelpAskPage',
      name:'HelpAskPage',
      component: comp.HelpCenter_HelpAskPage
    },{
      path:'/helpCenter/DemandProblem',
      name:'DemandProblem',
      component: comp.HelpCenter_DemandProblem
    }]
  },
  {
    path:'/displayBoard',
    name:'displayBoard',
    component:comp.DisplayBoard,
    redirect:'/displayBoard/workloadDetail',
    children: [{
      path:'/displayBoard/workloadDetail',
      name:'workloadDetail',
      component: comp.DisplayBoard_Detail
    },{
      path:'/displayBoard/workloadCollect',
      name:'workloadCollect',
      component: comp.DisplayBoard_Collect
    },]
  },
  {
    path: '/message',
    name: 'Message',
    redirect:'/message/messageCenter',
    component: comp.Message,
    children: [{
      path: '/message/messageCenter',
      name: 'MessageCenter',
      component: comp.Message_Center
    }]
  },
  {
    path: '/taskCenter',
    name: 'TaskCenter',
    redirect:'/taskCenter/missionCenter',
    component: comp.TaskCenter,
    children: [{
      path:'/taskCenter/missionCenter',
      name:'MissionCenter',
      component: comp.MissionCenter
    }]
  },
  {
    path: '/salary',
    redirect:'/salary/record',
    component: comp.Salary,
    children: [{
      path:'/salary/record',
      component: comp.Salary_Record
    },{
      path:'/salary/achievement',
      component: comp.Salary_Achievement
    },{
      path:'/salary/staff',
      component: comp.Salary_Staff
    },{
      path:'/salary/commision',
      component: comp.Salary_Commision
    }]
  },
  {
    path: '/finance',
    redirect:'/finance/cashExpense',
    component: comp.Finance,
    children: [
      {
        path:'/finance/cashExpense',
        component: comp.Finance_CashExpense
      },{
        path:'/salary/calculation',
        component: comp.Finance_Income
      },{
        path:'/finance/fund',
        component: comp.Finance_Fund
      },{
        path:'/finance/config',
        component: comp.Finance_Config
      },{
        path:'/finance/documentSet',
        component: comp.Finance_Document
      },{
        path:'/finance/wage',
        component: comp.Finance_Wage
      },{
        path: '/finance/billReceivable',
        component: comp.Finance_BillReceivable
      }
    ]
  },
]
const router = new Router({ routes })

const isIE = function () {
  console.log(window.navigator.userAgent)
  const userAgent = window.navigator.userAgent
  if(userAgent.indexOf('MSIE') >= 1) {
    return true
  } else {
    return false
  }
}

router.beforeEach((to, from, next) => {
  if(isIE() && to.path !== '/agentError') {
    next({
      path:'/agentError'
    })
  } else if(to.path === '/agentError'){
    next()
  } else if(to.path === '/login') {
    next()
  }else {
    if(Cookie.get('token')) {
      next()
    }else {
      next({
        path:'/login'
      })
    }
  }
})

router.afterEach((to,from,failure) => {
  const menu = store.state.menu
  const needSecondMenu = store.state.needSecondMenu
  if(menu.length > 0 && !needSecondMenu[to.path]){
    store.commit('setErrorTipsShowState',true)
    store.commit('setShowCheckPassword', false)
  }
})
// console.log(router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js